import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import {
  RICH_TEXT_TYPE_ID,
  DEFAULT_RICH_TEXT_CONTENT,
  PERSONS_LISTS_BY_DATE_TYPE_ID,
  DEFAULT_PERSON_LISTS_BY_DATE_CONTENT,
} from 'pages/Homepage/helpers/consts';
import { Widget, PersonListsByDatePersonList } from 'pages/Homepage/typings';

function buildWidgetWithDefaultValues(widget: Widget): Widget {
  if (!widget) {
    return widget;
  }

  const { widgetTypeId } = widget;

  if (widgetTypeId === RICH_TEXT_TYPE_ID) {
    return {
      ...widget,
      settings: {
        ...widget.settings,
        richTextDefault: _get(widget, ['settings', 'richTextDefault'])
          ? JSON.parse(_get(widget, ['settings', 'richTextDefault']))
          : JSON.parse(DEFAULT_RICH_TEXT_CONTENT),
        richTextExpanded: _get(widget, ['settings', 'richTextExpanded'])
          ? JSON.parse(_get(widget, ['settings', 'richTextExpanded']))
          : JSON.parse(DEFAULT_RICH_TEXT_CONTENT),
      },
    };
  } else if (widgetTypeId === PERSONS_LISTS_BY_DATE_TYPE_ID) {
    const existingLists = _get(widget, ['settings', 'personLists'], []);
    return {
      ...widget,
      settings: {
        ...widget.settings,
        personLists: _isEmpty(existingLists)
          ? [DEFAULT_PERSON_LISTS_BY_DATE_CONTENT]
          : existingLists.map((list: PersonListsByDatePersonList, i: number) => ({
              ...list,
              _targetListIndex: !_isNil(list._targetListIndex) ? list._targetListIndex : i,
            })),
      },
    };
  } else {
    return widget;
  }
}

export default buildWidgetWithDefaultValues;
